import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Module-scope cache: one fetch per browser session for the house logo +
// brand name (Mindful Minerals).  Used by Landing, TopNav and the DealerPage
// header to render a consistent brand identity.
let _housePromise = null;
let _houseCache = null;

export function useHouseBrand() {
  const [data, setData] = useState(_houseCache);
  useEffect(() => {
    if (_houseCache) {
      setData(_houseCache);
      return;
    }
    if (!_housePromise) {
      _housePromise = api
        .get("/postcue/public/orevital")
        .then((r) => {
          _houseCache = {
            logo:
              r.data?.dealer_logo ||
              "https://uploads.orevital.com/blue-logo.png",
            company: r.data?.company_name || "OreVital",
            slug: r.data?.slug || "orevital",
          };
          return _houseCache;
        })
        .catch(() => {
          _houseCache = {
            logo: "https://uploads.orevital.com/blue-logo.png",
            company: "OreVital",
            slug: "orevital",
          };
          return _houseCache;
        });
    }
    _housePromise.then((v) => setData(v));
  }, []);
  return (
    data || {
      logo: "https://uploads.orevital.com/blue-logo.png",
      company: "OreVital",
      slug: "orevital",
    }
  );
}
